{
  "name": "client-gallery-ui-ng",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "performance:measure": "node scripts/measure-ui-performance.mjs",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "playwright:test": "playwright test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.0",
    "@angular/cdk": "^20.2.10",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/platform-browser": "^20.0.0",
    "@angular/platform-browser-dynamic": "^20.0.0",
    "@angular/router": "^20.0.0",
    "@sentry/browser": "^7.120.4",
    "dayjs": "^1.11.13",
    "lightgallery": "^2.8.3",
    "litepicker": "^2.0.12",
    "ngx-color-picker": "^19.0.0",
    "ngx-cookie-service": "^20.0.1",
    "ngx-stripe": "^20.7.0",
    "ngx-turnstile": "^0.2.5",
    "postcss": "^8.5.3",
    "posthog-js": "^1.416.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.0.0",
    "@angular/cli": "^20.0.0",
    "@angular/compiler-cli": "^20.0.0",
    "@iconify-json/lucide": "^1.2.43",
    "@iconify-json/simple-icons": "^1.2.66",
    "@iconify/tailwind4": "^1.0.6",
    "@playwright/test": "^1.56.1",
    "@tailwindcss/postcss": "^4.1.6",
    "@tailwindcss/typography": "^0.5.16",
    "@types/jasmine": "~5.1.0",
    "daisyui": "^5.0.35",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.3",
    "tailwindcss": "^4.1.6",
    "tailwindcss-motion": "^1.1.1",
    "typescript": "~5.8.3"
  }
}
